import Vue from 'vue'
import VueResource from 'vue-resource'
import App from './App'
import Buefy from 'buefy'
import VueMasonry from 'vue-masonry-css'

Vue.use(VueMasonry);

Vue.use(Buefy,{
    defaultIconPack: 'fas'
})
Vue.use(VueResource)


Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
